import messagesApi from "@/api/messages"
import cnnSo from "@/stores/connections"
import { MESSAGE_TYPE } from "@/stores/log/utils"
import viewSetup, { ViewStore } from "@/stores/stacks/viewBase"
import { LOAD_STATE } from "@priolo/jack"
import { mixStores, StoreOf } from "@priolo/jon"
import { toPayload } from "../../../../utils/editor"
import editorSetup from "../../editorBase"



const setup = {

	state: {
		connectionId: <string>null,
		text: <string>null,
		subject: <string>null,
		subjects: <string[]>[],
		headers: <[string, string][]>[],
		subsOpen: false,

		loadingState: LOAD_STATE.IDLE,

		//#region VIEWBASE
		width: 420,
		//#endregion
	},

	getters: {

		//#region VIEWBASE
		getTitle: (_: void, store?: ViewStore) => "SEND MESSAGE",
		getSubTitle: (_: void, store?: ViewStore) => {
			const cnnId = (store.state as MessageSendState).connectionId
			const cnn = cnnSo.getById(cnnId)
			return cnn?.name ?? "--"
		},
		getSerialization: (_: void, store?: ViewStore) => {
			const state = store.state as MessageSendState
			return {
				...viewSetup.getters.getSerialization(null, store),
				connectionId: state.connectionId,
				text: state.text,
				subject: state.subject,
				subjects: state.subjects,
				headers: state.headers,
			}
		},
		//#endregion

		getEditorText: (_: void, store?: ViewStore) => (<MessageSendStore>store).state.text ?? "",

		getCanEdit: (_: void, store?: MessageSendStore) => store.state.subject?.length > 0 && store.state.loadingState != LOAD_STATE.LOADING,
	},

	actions: {

		//#region VIEWBASE
		setSerialization: (data: any, store?: ViewStore) => {
			viewSetup.actions.setSerialization(data, store)
			const state = store.state as MessageSendState
			state.connectionId = data.connectionId
			state.text = data.text
			state.subject = data.subject
			state.subjects = data.subjects
			state.headers = data.headers
		},
		//#endregion

		publish: async (_: void, store?: MessageSendStore) => {
			const { payload, error } = toPayload(store.state.text, store.state.format)
			if (error) {
				store.setSnackbar({
					open: true,
					type: MESSAGE_TYPE.ERROR,
					title: "MESSAGE NOT SENT",
					body: error,
					timeout: 4000,
				})
				return
			}
			try {
				await messagesApi.publish(
					store.state.connectionId,
					store.state.subject,
					payload,
					store.state.headers,
					{ store }
				)
				store.setSnackbar({
					open: true,
					type: MESSAGE_TYPE.INFO,
					title: "MESSAGE SENT",
					body: "Your message has been sent correctly",
					timeout: 2000,
				})
			} catch (e) { }
		},

	},

	mutators: {
		setText: (text: string, store?: MessageSendStore) => ({ text }),
		setSubject: (subject: string) => ({ subject }),
		setHeaders: (headers: [string, string][]) => ({ headers }),
		setSubsOpen: (subsOpen: boolean) => ({ subsOpen }),

		setLoadingState: (loadingState: LOAD_STATE) => ({ loadingState }),
	},
}

const msgSetup = mixStores(viewSetup, editorSetup, setup)
export interface MessageSendStore extends StoreOf<typeof msgSetup> {}
export type MessageSendState = MessageSendStore["state"]
export default msgSetup
